// Rolling buffer of recent API calls + JS errors. Attached automatically
// to bug reports so the office (and the builder) can diagnose issues
// without asking the reporter for technical details.
const MAX = 60;
const buf = [];

const push = (line) => {
  buf.push(`${new Date().toISOString().slice(11, 19)} ${line}`);
  if (buf.length > MAX) buf.shift();
};

export const installApiLogger = (axiosInstance) => {
  axiosInstance.interceptors.request.use((config) => {
    config.metadata = { start: Date.now() };
    return config;
  });
  axiosInstance.interceptors.response.use(
    (res) => {
      const ms = Date.now() - (res.config.metadata?.start || Date.now());
      push(`${(res.config.method || "get").toUpperCase()} ${res.config.url} → ${res.status} (${ms}ms)`);
      return res;
    },
    (err) => {
      const cfg = err.config || {};
      const ms = Date.now() - (cfg.metadata?.start || Date.now());
      const status = err.response?.status || "ERR";
      let detail = "";
      try { detail = JSON.stringify(err.response?.data?.detail ?? err.message).slice(0, 300); } catch { detail = String(err.message); }
      push(`${(cfg.method || "get").toUpperCase()} ${cfg.url} → ${status} (${ms}ms) ${detail}`);
      return Promise.reject(err);
    },
  );
};

if (typeof window !== "undefined" && !window.__feedbackErrHook) {
  window.__feedbackErrHook = true;
  window.addEventListener("error", (e) => push(`JS ERROR: ${e.message} @ ${e.filename}:${e.lineno}`));
  window.addEventListener("unhandledrejection", (e) => push(`PROMISE ERROR: ${String(e.reason).slice(0, 300)}`));
}

export const getApiLog = () =>
  buf.length ? `Page: ${window.location.pathname}\nUA: ${navigator.userAgent}\n\n${buf.join("\n")}` : "";
